import { render, staticRenderFns } from "./ColorHueVarianceChart.vue?vue&type=template&id=326e08d7&scoped=true&"
import script from "./ColorHueVarianceChart.vue?vue&type=script&lang=ts&"
export * from "./ColorHueVarianceChart.vue?vue&type=script&lang=ts&"
import style0 from "./ColorHueVarianceChart.vue?vue&type=style&index=0&id=326e08d7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "326e08d7",
  null
  
)

export default component.exports